import { AuthenticationMethod, DeliveryType, MessageSource, MessageStatus, MessageType } from "../../../../src/Core/Common/Enums";
import { IReceivedMessageModel } from "./ReceivedMessageModel";
import { ISentMessageRecipientModel } from "./SentMessageRecipientModel";

export interface ISentMessageModel {
    type?: MessageType; //discriminator
    folderId: number;
    sentMessageId: number;
    sentMessageGuid: string;
    senderId: number;
    senderEmail: string;
    senderFirstName: string;
    senderLastName: string;
    subject: string;
    message: string;
    notifyWhenDownloaded: number;
    sentDate: Date;
    expiresDays: number;
    authenticationMethod: AuthenticationMethod;
    linkId: string;
    messageStatus: MessageStatus;
    messageSource: MessageSource;
    deletedBySender: boolean;
    uploadRetry: number;
    isDeleted: boolean;
    sentMessageRecipients: ISentMessageRecipientModel[];
    recipientList: string;
    senderFilePath: string;
    filteredMessage: string;
    threadId?: string;
    deliveryType?:DeliveryType;
    threadMessages?: ISentMessageModel[];
    hasAttachments?: number;
    receivedMessageId?: number;
    receivedMessageGuid?: string;
    messageType: MessageType;
    associatedFolderId?: number;
    taxYear: number;
}

export const initialSentMessage: ISentMessageModel = {
    sentMessageId: 0,
    sentMessageGuid: "",
    senderId: 0,
    senderEmail: "",
    senderFirstName: "",
    senderLastName: "",
    subject: "",
    message: "",
    notifyWhenDownloaded: 0,
    sentDate: new Date(),
    expiresDays: 30,
    authenticationMethod: AuthenticationMethod.ACCESSCODE,
    linkId: "",
    messageStatus: MessageStatus.Pending,
    messageSource: MessageSource.WEBADDIN,
    deletedBySender: false,
    uploadRetry: 1,
    isDeleted: false,
    sentMessageRecipients: [],
    recipientList: "",
    senderFilePath: "",
    filteredMessage: "",
    messageType: MessageType.UNKNOWN,
    folderId:0,
    taxYear: 0,
};
export interface IDocumentPagination {
    pageSize: number;
    currentPage: number;
}

export const initialMessage: ISentMessageModel | IReceivedMessageModel = {
    sentMessageId: 0,
    sentMessageGuid: "",
    receivedMessageId: 0,
    receivedMessageGuid: "",
    senderId: 0,
    senderEmail: "",
    senderFirstName: "",
    senderLastName: "",
    subject: "",
    message: "",
    notifyWhenDownloaded: 0,
    sentDate: new Date(),
    expiresDays: 0,
    authenticationMethod: AuthenticationMethod.ACCESSCODE,
    linkId: "",
    messageStatus: MessageStatus.Pending,
    messageSource: MessageSource.MAILBOX,
    deletedBySender: false,
    uploadRetry: 1,
    isDeleted: false,
    sentMessageRecipients: [],
    recipientList: "",
    filteredMessage: "",
    senderFilePath: "",
    messageType: MessageType.UNKNOWN,
    folderId:0,
    taxYear:0,

};